"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatHours = exports.formatRate = void 0;

var padCents = function padCents(cents) {
  var fullStr = "00".concat(cents);
  return fullStr.substr(fullStr.length - 2);
};

var formatRate = function formatRate(rate) {
  var dollars = Math.floor(rate);
  var cents = rate % 1 * 100;
  return "$".concat(dollars, ".").concat(padCents(cents));
};

exports.formatRate = formatRate;

var formatHours = function formatHours(hrs) {
  return parseFloat(Math.round(hrs * 10) / 10).toFixed(1);
};

exports.formatHours = formatHours;